import { getCsrfToken } from "@/lib/csrf"
import { getJson } from "@/lib/fetch-json"
import type { ContactAssigneesPickerData } from "@/types/v2/contact"

// Fetch and update contact assignment. Mirrors the pattern
// in buy-number-api.ts — GET returns camelCase JSON already,
// PATCH sends the snake_case form key the Rails controller
// expects. Callers check `res.status === 204` for success.

// GET /v2/contacts/assignees?q=<query>
// Returns the full employee list when q is empty; filtered
// when q is non-empty. The controller does server-side
// filtering so the client can also do a lightweight
// client-side pass on the already-loaded list.
export async function fetchContactAssignees(
  q: string,
  signal?: AbortSignal,
): Promise<ContactAssigneesPickerData> {
  const params = new URLSearchParams()
  if (q) params.set("q", q)
  return getJson<ContactAssigneesPickerData>(
    `/v2/contacts/assignees?${params.toString()}`,
    signal,
  )
}

// PATCH /v2/contacts/:contactId/assignment
// Body: { v2_contacts_assignments_update_form: { employee_ids: number[] } }
// Returns a raw Response so the caller can check status
// (204 = success, 422 = validation errors).
export function updateContactAssignment(
  contactId: number,
  employeeIds: number[],
): Promise<Response> {
  return fetch(`/v2/contacts/${contactId}/assignment`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": getCsrfToken(),
    },
    credentials: "same-origin",
    body: JSON.stringify({
      v2_contacts_assignments_update_form: {
        employee_ids: employeeIds,
      },
    }),
  })
}
